import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow, IconButton } from "@similarweb/ui-components";

const { carbon, midnight } = colorsPalettes;

export const ButtonContainer = styled.div`
    margin-left: auto;

    div {
        margin-right: 8px;
    }
`;

ButtonContainer.displayName = "ButtonContainer";

export const AISuggestionReasonText = styled.p`
    width: 450px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    margin: 4px 0 0;

    ${setFontVariant("body2", carbon[300])};
`;

export const ItemContainer = styled(FlexRow)<{ isDisabled: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 77px;

    padding: 16px;

    box-sizing: border-box;
    background-color: transparent;
    border-radius: 4px;
    flex-shrink: 0;
    cursor: pointer;
    border: 1px solid ${carbon[50]};

    &:hover {
        border: 1px solid ${carbon[100]};

        & ${AISuggestionReasonText} {
            color: ${carbon[500]};
        }
    }

    ${({ isDisabled }) =>
        isDisabled &&
        css`
            cursor: not-allowed;

            &:hover {
                box-shadow: none;
            }
        `};
`;

ItemContainer.displayName = "ItemContainer";

export const IconsContainer = styled.div`
    width: 32px;
    height: 32px;
    border: 1px solid ${midnight[50]};
    border-radius: 4px;
    background-color: ${carbon[0]};
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-right: 16px;
    box-shadow: 0px 3px 5px rgba(42, 62, 82, 0.12);
    flex-shrink: 0;
`;

const StyledIconButton = styled(IconButton)`
    padding: 4px;
`;
